import React, { useState, useImperativeHandle, forwardRef, useEffect } from 'react';
import './Toast.css';
import checkIcon from '../../assets/img/icons/check.png';

function Toast(props, ref) {

    const [state, setState] = useState({
        visible: false,
        message: '',
        type: 'success', // success, error, info, warning
        duration: 3000
    });

    useImperativeHandle(ref, () => ({
        show: (message, type = 'success', duration = 3000) => {
            setState(prev => ({
                ...prev,
                visible: true,
                message: message,
                type: type,
                duration: duration
            }));

            // Auto hide after duration
            setTimeout(() => {
                setState(prev => ({
                    ...prev,
                    visible: false
                }));
            }, duration);
        },
        hide: () => {
            setState(prev => ({
                ...prev,
                visible: false
            }));
        }
    }));

    const handleClose = () => {
        setState(prev => ({
            ...prev,
            visible: false
        }));
    };

    return (
        <div className={`toast-container ${state.visible ? 'show' : ''} toast-${state.type}`}>
            <div className="toast-content">
                {state.type === 'success' && (
                    <div className="toast-icon-circle">
                        <img src={checkIcon} alt="success" className="toast-icon" />
                    </div>
                )}
                <span className="toast-message">{state.message}</span>
                <button className="toast-close" onClick={handleClose}>
                    ×
                </button>
            </div>
        </div>
    );
}

export default forwardRef(Toast);
